import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/es/checkbox';

export type ICheckboxGroupProps = CheckboxGroupProps;

export default Checkbox.Group;
